import { MultiService } from 'modules/api/MultiService';

export interface IAutorizeWorkerParams {
  workerToken: string;
}

export const autorizeWorker = ({ workerToken }: IAutorizeWorkerParams) => {
  const service = MultiService.getService();

  service.getWorkerGateway().addJwtToken(workerToken);
};
